
import { getMetricsApiPrefix, metricsFetch } from '../../config/EnvData';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import Checkbox from '@mui/material/Checkbox';

import * as FaIcons from "react-icons/fa";
import React, { useState,useEffect,useRef } from "react";
import axios from 'axios';
import {useFetcher, useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import styled from "styled-components";
import Slider from '@mui/material/Slider';
import AirportCarousel from '../../components/AirportCarousel';
import {roundToNthNearestMinute} from "../../utils/funcs.js"
import {PlotSectionDiv,EpochDataBlock} from '../../components/DisplayComponents';
import {PlotLoadingOverlay} from '../../components/PlotLoadingOverlay';

const DEG_TO_NM   = 60.0405
const NM_TO_DEG   = 1/DEG_TO_NM


const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;

const TitleDiv = styled.div`
    min-width:85vw;
`;
const colorPalette = ['#2E91E5','#E15F99','#1CA71C','#FB0D0D','#DA16FF','#222A2A','#B68100','#750D86','#EB663B','#511CFB',
					'#FB0D0D','#DA16FF','#222A2A']
const zoomPlusEvent = new KeyboardEvent('keydown', {
  key: '+',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

const zoomMinusEvent = new KeyboardEvent('keydown', {
  key: '-',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

// <TitleDiv>
            // <h1 style={{marginLeft:'10px'}}>{airport+', '+airportData['city']+' - Mashup Dashboard'}</h1>
        // </TitleDiv>

const homePlotlyIcon = {
            width: 928.6,
            height: 1000,
            path: 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
            transform: 'matrix(1 0 0 -1 0 850)'
        }

const sliderMarks = [
  {
    value: 0,
    label: '5 min',
  },
  {
    value: 1,
    label: '1 hour',
  },
  {
    value: 2,
    label: '24 hours',
  },
];
const axesLineColor ='#FFFF'//'rgba(220,232,247,0.1)'
const axesLineWidth = 5


const countLevels = [15,30,60,120,720,1440,7200]
const countLevelLabels = {'15min': '15 min',
                              '30min':'30 min',
                              '60min':'1 hr',
                              '120min':'2 hr',
                              '720min':'12 hr',
                              '1440min':'1 day',
                              '7200min':'5 days'}

const GoArounds = ({setTitle,pageTitle,metricLookBackHorizonDays,backendApiPrefix}) => {
    const {airport} = useParams()
    const [isChartLoading,setIsChartLoading] = useState(true)
    const [isMapLoading,setIsMapLoading] = useState(true)
    const [lastUpdatedTime,setLastUpdatedTime] = useState(new Date())

    const [queryIterTime,setQueryIterTime] = useState(new Date())
    const [metricStartTime,setMetricStartTime] = useState(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))

    const [airportMapTrace,setAirportMapTrace] = useState({type: "scattermapbox",
                                                           lat: [],
                                                           lon: [],
                                                           text:[],
                                                           textfont:{size:16,color:'black'},
                                                           textposition:'top right',
                                                           marker: {symbol:'marker',color: "black", size: 10,allowoverlap:true},
                                                           hoverinfo:'skip',
                                                           name:'',
                                                           mode:'markers+text',
                                                           hovertemplate:'<extra></extra>',
                                                           showlegend:false})
    
    const [countLevelChecked,setCountLevelChecked] = useState(countLevels.reduce((acc,key)=>{acc[key]=(key===15)?true:false;return acc},{}))
    const [maxCountLevelChecked,setMaxCountLevelChecked] = useState(5)
    const [aircraftTracksTraces,setAircraftTracksTraces] = useState([])
    
    useEffect(() => {
        setTitle(pageTitle=>'Go Arounds - '+airport)
    },[airport]);
    // {

    //     name: 'color toggler',
    
    //     icon: icon1,
    
    //     click: function(gd) {
    
    //         var newColor = colors[Math.floor(3 * Math.random())]
    
    //         Plotly.restyle(gd, 'line.color', newColor)
    
    //     }},
    const [airportData, setAirportData] = useState({'location':[],'city':''}); 
    
    const [selectedEpoch,setSelectedEpoch] = useState('')
    const [selectedPointIndex,setSelectedPointIndex] = useState(-1)

    const [epochString,setEpochString] = useState([])
    const [latestEpochFlag,setLatestEpochFlag] = useState(true)

    const countLevelKeys = countLevels.reduce((acc,key)=>{acc[key+'min']='';return acc},{})
    const [goAroundCounts,setGoAroundCounts] = useState(countLevelKeys)
    const [holdingPatternCounts,setHoldingPatternCounts] = useState(countLevelKeys)
    const [clickMarkerYMax,setClickMarkerYMax] = useState(1)
    const [clickMarkerY2Max,setClickMarkerY2Max] = useState(1)
    const [plotMapLayout, setPlotMapLayout] = useState({
        mapbox: 
        { 
            style: "light", 
            center:{lat:null,lon:null},
            bounds:{'north':null,
                     'east':null,
                    'south':null,
                     'west':null},
            zoom:7,
            accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
            domain:{'x':[0.01,1],'y':[0.01,0.99]}
        },
        margin:{l:10,t:10,r:12,b:10},
        xaxis:{showline:true, linewidth:1, linecolor:'gray', mirror:true},
        yaxis:{showline:true, linewidth:1, linecolor:'gray', mirror:true},
        showlegend:false,plot_bgcolor:'rgba(220,232,247,0.4)'
        },
        );

    const [plotChartLayout, setPlotChartLayout] = useState({grid:{rows:3,columns:1,ygap:0.2},
            xaxis:{anchor:('y','y2'),
                zeroline:false,
                range:[queryIterTime,queryIterTime],
                rangeselector:{
                        buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                            {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                            {count:1,label:'1d',step:'day',stepmode:'backward'},

                            {step:'all'}]},
                type:'date',  		
                showticklabels:true,
                nticks:7,mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth,
                autorange:true},
        yaxis:{anchor:'x',title:'Go-Around<br>Counts',zeroline:false,domain:[0.63,1],showticklabels:true,autorange:true,
            mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth},
        legend:{x:0,xanchor:'left',y:1.02,bgcolor:'rgba(0,0,0,0)',orientation:'h'},
        //xaxis2:{showticklabels:true},
        xaxis2:{zeroline:false,showticklabels:true,range:[epochString[0],
            epochString[epochString.length-1]],mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth},
        yaxis2:{title:'Holding Pattern<br>Counts',zeroline:false,domain:[0.2,0.57],showticklabels:true,autorange:true,
            mirror:'all',linecolor:axesLineColor,linewidth:axesLineWidth},
        xaxis3:{anchor:'y3',zeroline:false,domain:[0.0,1]},
        yaxis3:{title:{text:'Arrival Counts',standoff:12},anchor:'x3',zeroline:false,domain:[0.0,0.34]},
    annotations:[],
    margin:{t:54,r:10,b:10},
    height:350,
    hovermode:'x unified',
    plot_bgcolor:'rgba(220,232,247,0.4)'});

    const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
        'toggleSpikelines','select2d',
        'zoomIn2d','zoomOut2d','lasso2d',
        'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
        'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
        'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
        'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
        'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
        'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
         displaylogo:false,responsive:true})

    // const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
    //     'toggleSpikelines','select2d',
    //     'zoomIn2d','zoomOut2d','lasso2d',
    //     'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
    //     'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
    //     'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
    //     'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
    //     'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
    //     'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
    //      displaylogo:false,responsive:true})

    
    
    const [leftDivHeight, setLeftDivHeight] = useState(null);
    const [leftDivWidth, setLeftDivWidth] = useState(null);
    
    const [rightDivHeight, setRightDivHeight] = useState(null);
    const [rightDivWidth, setRightDivWidth] = useState(null);
    
    const [revKey, setRevKey] = useState(0);
    
    useEffect(() =>{
      setTimeout(()=>{
      setPlotChartLayout({...plotChartLayout,
                          width:0.98*leftDivWidth
                        });
      
      // setPlotMapLayout({...plotMapLayout,
                       // width:0.98*rightDivWidth,
                       // });
                       
      setPlotMapLayout({...plotMapLayout,
                           width:0.98*rightDivWidth,
                           mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    },
                            zoom:7});
                                    
      setAirportMapTrace({...airportMapTrace,
                        lat: [airportData['location'][0]],
                        lon: [airportData['location'][1]],
                        text:[airport],
                        name:airport,
                        hovertemplate:'<extra></extra>'+airport,
                        })
                       
      },20)
    },[leftDivWidth,rightDivWidth,airportData]);
    
    useEffect(() => {
        axios.post(backendApiPrefix+'/api/get-airport-data/',{airport:airport})
            .then(response => {
                var jsonData = response.data.message
                console.log(jsonData)
                setAirportData(jsonData)
             })
            .catch(error => {
                console.log(error);
            });
        setAircraftTracksTraces([])
    },[airport]);
    
    
    useEffect(() => {
        const QUERY_CHUNK_HOURS = 12;
        if(queryIterTime.getTime() >= metricStartTime.getTime()){
            var queryEndTime = queryIterTime
            var shiftedQueryIterTime = new Date(queryIterTime.getTime() - QUERY_CHUNK_HOURS* 60*60*1000)
            var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
            var queryEndTimeForAPIQuery = queryEndTimeComps[3]+queryEndTimeComps[2]+queryEndTimeComps[1]+queryEndTimeComps[4]+queryEndTimeComps[5]

            var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
            var queryStartTimeForAPIQuery = queryStartTimeComps[3]+queryStartTimeComps[2]+queryStartTimeComps[1]+queryStartTimeComps[4]+queryStartTimeComps[5]
            axios.post(backendApiPrefix+'/api/get-go-around-counts-data/',{airport:airport,from:queryStartTimeForAPIQuery,to:queryEndTimeForAPIQuery})
                .then(response => {
                    var jsonData = response.data.message
                    setQueryIterTime(shiftedQueryIterTime)
                    setEpochString([...jsonData.epochString,...epochString])
                    if(latestEpochFlag&&selectedEpoch===''){
                        if(epochString.length > 0){
                            setSelectedEpoch(epochString[epochString.length-1])
                        }else{
                            setSelectedEpoch(jsonData.epochString[jsonData.epochString.length-1])
                        }
                    }
                    
                    
                    var goAroundCountVals = {};
                    var holdingPatternCountVals = {};
                    for(var lv of countLevels){
                        if(Object.hasOwn(goAroundCounts,lv+'min')){
                            goAroundCountVals[lv+'min'] = [...jsonData['goAround'+lv+'min'],...goAroundCounts[lv+'min']]
                        }
                        else{
                            goAroundCountVals[lv+'min'] =jsonData['goAround'+lv+'min']
                        }
                        if(Object.hasOwn(holdingPatternCounts,lv+'min')){
                            holdingPatternCountVals[lv+'min'] = [...jsonData['holdingPattern'+lv+'min'],...holdingPatternCounts[lv+'min']]
                        }
                        else{
                            holdingPatternCountVals[lv+'min'] = jsonData['holdingPattern'+lv+'min']
                        }
                        
                    }
                    setGoAroundCounts({...goAroundCounts,...goAroundCountVals})
                    setHoldingPatternCounts({...holdingPatternCounts,...holdingPatternCountVals})

                    // setPlotChartLayout({...plotChartLayout,
                    //     yaxis:{...plotChartLayout.yaxis
                    //     },
                    //     yaxis2:{...plotChartLayout.yaxis2
                    //     }})
                    setIsChartLoading(false)
            })
                .catch(error => {
                    console.log(error);
                    setIsChartLoading(false)
                });
            }
        else{
            fetchAndUpdateGoAroundTracks(selectedEpoch)

            }},[queryIterTime,selectedEpoch,epochString])      
    useEffect(() => {
                setPlotMapLayout({...plotMapLayout,
                                    mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    zoom:7}});
                                    
        setAirportMapTrace({...airportMapTrace,
                            lat: [airportData['location'][0]],
                            lon: [airportData['location'][1]],
                            text:[airport],
                            name:airport,
                            hovertemplate:'<extra></extra>'+airport,
                            })
    },[airportData])
    
    useEffect(() =>{
        setClickMarkerYMax(Object.hasOwn(plotChartLayout.yaxis,'range')?plotChartLayout.yaxis.range[1]:1)
        setClickMarkerY2Max(Object.hasOwn(plotChartLayout.yaxis2,'range')?plotChartLayout.yaxis2.range[1]:1)
    },[queryIterTime,plotChartLayout])
    const mounted = useRef();
    useEffect(() => {
       if(mounted.current){
           // Component mounted
           console.log("Updated")
       } else {
            console.log("Mounted")
            mounted.current = true
            
       }
    });
    // const chartDiv = useCallback(node => {
        // if (node !== null) {
          // setLeftDivHeight(node.getBoundingClientRect().height);
          // setLeftDivWidth(node.getBoundingClientRect().width);
          // console.log("HEIGHT",height)
          // console.log("HEIGHT",width)
        // }
        // }, []);
    const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // This will be called on both refresh and page close
      setIsRefreshing(true);
      setRevKey(prevVal => prevVal +1)
      // The following is necessary for older browsers
      event.preventDefault();
      event.returnValue = '';
    };

    
    window.addEventListener('load', handleBeforeUnload);

    return () => {
      window.removeEventListener('load', handleBeforeUnload);
    };
  });

  useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setLeftDivWidth(event[0].contentBoxSize[0].inlineSize);
            setLeftDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyChartDiv"));
        
        
    });
    useEffect(() =>{
    },[])
    
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
            setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyMapDiv"));
    });
    const [menuOption, setMenuOption] = React.useState(1);

    const handleChange = (event: SelectChangeEvent) => {
        setMenuOption(String(event.target.value));
      };
    useEffect(()=>{
        console.log("HERE")
        if(selectedEpoch){
            console.log("HERE-HERE")
            fetchAndUpdateGoAroundTracks(selectedEpoch)
        }
    },[countLevelChecked,maxCountLevelChecked]);
    
    const fetchAndUpdateGoAroundTracks=(epochVal)=>{
        var epochStringComps = epochVal.split(/-| |:/) 
        var epochFormatForAPIQuery = epochStringComps[0]+monthNames[parseInt(epochStringComps[1])-1]+
                                epochStringComps[2]+epochStringComps[3]+epochStringComps[4]
        
        console.log("Epoch for query")
        console.log(epochFormatForAPIQuery)
        console.log("maxCountLevel",maxCountLevelChecked)
        
        var goAroundTrackData_api = getMetricsApiPrefix() + 'go-around-counts/get-tracks-for-epoch?'+
                                                'airport='+airport+'&epoch='+epochFormatForAPIQuery+'&durationMinutes='+maxCountLevelChecked
        console.log(goAroundTrackData_api)
        Promise.all([
            metricsFetch(goAroundTrackData_api)
        ]).then(function (responses) {
            // Get a JSON object from each of the responses
            return Promise.all(responses.map(function (response) {
                return response.json();
            }));
        }).then(function (json_data_array) {
            updateTracksOnMap(json_data_array[0])
            setIsMapLoading(false)
        }).catch(error => {
            console.log(error);
            setIsMapLoading(false)
        });
    }
    const handleLatestEpochButton = () =>{
        setLatestEpochFlag(true)
        setSelectedEpoch(epochString[epochString.length-1])
        setSelectedPointIndex(epochString.length-1)
        // setPlotChartLayout({...plotChartLayout,
        //                        yaxis:{...plotChartLayout.yaxis,
        //                                 range:[0,1.2*Math.max(...meanCenterlineDeviation.mean)]
        //                        },
        //                        yaxis2:{...plotChartLayout.yaxis2,
        //                         range:[0,1.2*Math.max(...meanVerticalDeviation.mean)]
        //                }})
        fetchAndUpdateGoAroundTracks(epochString[epochString.length-1])

    };
    function updateTracksOnMap(trackData){   
        
        var trackTrace = []
        for(var idx in trackData){
            var rwyInfo
            if(trackData[idx]['type'] === 'goAround'){
                rwyInfo = '<b>Rwy: </b>'+trackData[idx]['rwy']+'<br>';
            }else{
                rwyInfo = '';
            }
            trackTrace.push({type:'scattermapbox',
                             lat:trackData[idx].latitude,
                             lon:trackData[idx].longitude,
                             text:trackData[idx].altitude,
                             name:trackData[idx].acid,
                             meta:[trackData[idx].acid,trackData[idx].aircraftType,rwyInfo,trackData[idx]['type']],
                             hovertemplate:'<extra>%{meta[3]}</extra><b>%{meta[0]} (%{meta[1]})</b><br>%{meta[2]}<b>Lat</b>:%{lat:.2f} <b>Lon</b>:%{lon:.2f} <b>Alt</b>:%{text:.0f}ft',
                             mode:'lines',
                             marker:{size:6},
                             hoverlabel:{bgcolor:'white'}
            })
        }
        setAircraftTracksTraces(trackTrace)
        // var additionalData = []
        // for(var idx in conflictData['Acid_AC1']){
        //     additionalData.push([conflictData['Acid_AC1'][idx],conflictData['Acid_AC2'][idx],
        //                          conflictData['ConformanceCat'][idx],conflictData['ConflictAirspaceClass_AC1'][idx]])
        // }
        // for(var idx in conflictData['Acid_AC2']){
        //     additionalData.push([conflictData['Acid_AC2'][idx],conflictData['Acid_AC1'][idx],
        //                          conflictData['ConformanceCat'][idx],conflictData['ConflictAirspaceClass_AC2'][idx]])
        // }
        // if(conflictData.hasOwnProperty('ConflictLat_AC1')){
        //         console.log(conflictData)
        //         setAircraftTracksTraces({...aircraftTracksTraces,
        //                                     lat:conflictData['ConflictLat_AC1'].concat(conflictData['ConflictLat_AC2']),
        //                                     lon:conflictData['ConflictLon_AC1'].concat(conflictData['ConflictLon_AC2']),
        //                                     text:conflictData['ConflictAlt_AC1'].concat(conflictData['ConflictAlt_AC2']),
        //                                     customdata:additionalData})
        // }else{
        //     setAircraftTracksTraces({...aircraftTracksTraces,
        //                                 lat:[],lon:[],text:[],customdata:[]});
        // }
    }
    const handleDoubleClickOnMap=(data)=>{
        setPlotMapLayout({...plotMapLayout,
            mapbox: {...plotMapLayout.mapbox,
                        center:{
                        lat:airportData['location'][0],
                        lon:airportData['location'][1]
                        },
                        bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                             'east':airportData['location'][1]+200*NM_TO_DEG,
                            'south':airportData['location'][0]-200*NM_TO_DEG,
                             'west':airportData['location'][1]-200*NM_TO_DEG},
            zoom:7}});
    }
    const handleClickOnChart=(data)=>{
        console.log(data)
        setLatestEpochFlag(false)

        var point = data.points[0]
        
        if(!(new Date(point.x) instanceof Date && !isNaN(new Date(point.x).valueOf()))){
            return;
        }
        console.log(point)
        console.log(point.pointIndex)
        console.log(epochString[point.pointIndex])
        setSelectedEpoch(epochString[point.pointIndex])
        setSelectedPointIndex(point.pointIndex)
        // setPlotChartLayout({...plotChartLayout,
        //                        yaxis:{...plotChartLayout.yaxis,
        //                                 range:[0,0.99*plotChartLayout.yaxis.range[1]]
        //                        },
        //                        yaxis2:{...plotChartLayout.yaxis2,
        //                         range:[0,0.99*plotChartLayout.yaxis2.range[1]]
        //                },
        // })

        fetchAndUpdateGoAroundTracks(epochString[point.pointIndex])
    };
    const handleClickOnCheckbox=(e,lvl)=>{        
        console.log(lvl)
        if(!countLevelChecked[lvl]){
            if(lvl > maxCountLevelChecked){
                setMaxCountLevelChecked(lvl)
            }
            setClickMarkerYMax(plotChartLayout.yaxis.range[1] > goAroundCounts[lvl+'min']?
                                                plotChartLayout.yaxis.range[1]:1.2*Math.max(...goAroundCounts[lvl+'min']))
            setClickMarkerY2Max(plotChartLayout.yaxis2.range[1] > holdingPatternCounts[lvl+'min']?
                                                plotChartLayout.yaxis2.range[1]:1.2*Math.max(...holdingPatternCounts[lvl+'min']))
        }else{
            console.log(lvl,maxCountLevelChecked)
            console.log(Object.entries(countLevelChecked))
            if(lvl === maxCountLevelChecked){
                var mxLevel = Math.max(...Object.entries(countLevelChecked).filter(([key, value]) => value&&(key!==maxCountLevelChecked.toString())) // Filter entries based on the criterion
                                            .map(([key, value]) => key));
                if(mxLevel&&(mxLevel !== 1/0)&&(mxLevel !== -1/0)){
                    setMaxCountLevelChecked(mxLevel)
                    setClickMarkerYMax(plotChartLayout.yaxis.range[1] > 1.3*Math.max(...goAroundCounts[mxLevel+'min'])?
                                            1.2*Math.max(...goAroundCounts[mxLevel+'min']):plotChartLayout.yaxis.range[1])
                    setClickMarkerY2Max(plotChartLayout.yaxis2.range[1] > 1.3*Math.max(...holdingPatternCounts[mxLevel+'min'])?
                                                1.2*Math.max(...holdingPatternCounts[mxLevel+'min']):plotChartLayout.yaxis2.range[1])
                }
            }
        }
        setCountLevelChecked({
            ...countLevelChecked,
            [lvl]:!countLevelChecked[lvl]
        })
        

    };
    var goAroundTraces = []; var holdingPatternTraces = []
    for(var idx in countLevels){
        var lvl = countLevels[idx]
        if(!countLevelChecked[lvl]){
            continue;
        }
        goAroundTraces.push({
            x: epochString.length>0?epochString:[metricStartTime,queryIterTime],
            y: epochString.length>0?goAroundCounts[lvl+'min']:[0,0],
            type: 'scatter',
            mode: 'lines',
            marker: {color: colorPalette[idx]},
            hovertemplate:'%{y}<extra>'+countLevelLabels[lvl+'min']+'</extra>',
            name:'Go-around Counts ('+countLevelLabels[lvl+'min']+')',
            xaxis:'x',
            yaxis:'y',
            showlegend:false
          })    
          holdingPatternTraces.push({
            x: epochString.length>0?epochString:[metricStartTime,queryIterTime],
            y: epochString.length>0?holdingPatternCounts[lvl+'min']:[0,0],
            type: 'scatter',
            mode: 'lines',
            marker: {color: colorPalette[idx]},
            hovertemplate:'%{y}<extra>'+countLevelLabels[lvl+'min']+'</extra>',
            name:'Holding Pattern Counts ('+countLevelLabels[lvl+'min']+')',
            xaxis:'x',
            yaxis:'y2',
            showlegend:false
          })
    }    

    return (
        <Layout>
        <PlotSectionDiv id="chartPlotDiv" flexRatio={5}>
            <PlotLoadingOverlay show={isChartLoading}/>
            <EpochDataBlock selectedEpoch={selectedEpoch} handleLatestEpochButton={handleLatestEpochButton}
                            lastUpdatedTime={lastUpdatedTime}/>
            <div>
            <Plot  data={[
                    ...goAroundTraces,
                    ...holdingPatternTraces,
                  { x:[selectedEpoch,selectedEpoch],
                    y:[0,clickMarkerYMax],
					type:'scatter',
					xaxis:'x',yaxis:'y',
					mode:'lines',
					showlegend:false,
					hoverinfo:'skip',
					hovertemplate:'<extra></extra>',
					line:{color:'black',dash:'dashdot'}},
			      { x:[selectedEpoch,selectedEpoch],
                    y:[0,clickMarkerY2Max],
					type:'scatter',
					xaxis:'x',yaxis:'y2',
					mode:'lines',
					showlegend:false,
					hoverinfo:'skip',
					hovertemplate:'<extra></extra>',
					line:{color:'black',dash:'dashdot'}},
                ]}
                layout= {plotChartLayout}
                config= {{...plotConfig,scrollZoom:true}}
                divId={'plotlyChartDiv'}
                style={{minWidth:'300px',height:'55%',flex:1}}
                useResizeHandler={true}
                onClick={handleClickOnChart}
                onDoubleClick={()=>{}}
              />
              </div>    
        <div style={{textAlign:'left',position:'relative',marginLeft:'70px',marginRight:'70px',marginTop:'15px',display:'flex',flex:'1 1 auto',flexWrap:'wrap',justifyContent:'flex-start'}}>
        {countLevels.map((lvl)=>{
                return( <div style={{width:'120px',color:'#275AA6'}}>
                            <Checkbox  checked={countLevelChecked[lvl]} 
                                        onChange={(e)=>{handleClickOnCheckbox(e,lvl)}
                                                }
                            />
                            {countLevelLabels[lvl+'min']}
                        </div>)})}
        </div>
        </PlotSectionDiv>
        <PlotSectionDiv id="mapPlotDiv" key={revKey} flexRatio={3}>
            <PlotLoadingOverlay show={isMapLoading} label="Loading map…"/>
            <Plot data={[airportMapTrace,...aircraftTracksTraces]}
                  layout= {plotMapLayout}
                  config= {plotConfig}
                  useResizeHandler={true}
                  divId={'plotlyMapDiv'}
                  style={{minWidth:'300px',height:'90%',position:'relative',borderWidth:'2px',color:'yellow',
                            borderSyle:'solid',
                            borderColor:'black'}}
                  onDoubleClick={handleDoubleClickOnMap}
            />
        </PlotSectionDiv>  
        </Layout>
    );
};

export default GoArounds


